import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';


// Définit les langues disponibles
const availableLanguages = ['fr', 'en', 'es', 'de'];

// Récupère la langue principale du navigateur (ex: 'fr' pour 'fr-FR')
const browserLanguage = navigator.language.split(/[-_]/)[0];

// utilise la langue du navigateur si elle est dans availableLanguages, sinon utilise 'en'
const fallbackLng = [availableLanguages.includes(browserLanguage) ? browserLanguage : 'en'];

i18n
  .use(Backend) // load translation using xhr -> see /public/locales
  // .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    fallbackLng, // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
    debug: false,
    backend: {
      loadPath: 'locales/{{lng}}/{{ns}}.json'
    },
    // whitelist: availableLanguages,
    interpolation: {
      escapeValue: false
    },
    react: {
       useSuspense: false
    }
  });

export default i18n;
